/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a customer organization on a paid plan and invite its admin." |
*
* @param {Partner_Add_Customer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_description = /** @type {((inputs?: Partner_Add_Customer_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie eine Kundenorganisation mit kostenpflichtigem Tarif und laden Sie deren Admin ein.")
	return /** @type {LocalizedString} */ ("Create a customer organization on a paid plan and invite its admin.")
});